import React from "react";
import {pageNameDisplayOverride} from '../helpers'

import generalStore from './Stores/SurveyStore'
import ibsStore from './Stores/IbsSurveyStore'
import { BeatLoader } from 'react-spinners';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { observer } from "mobx-react";
import SurveySection from '../components/SurveySection';
import { validateSurveyCrtl, submitSurveyCtrl } from '../control';
import { css } from '@emotion/core';
import { PlaceholderFormat, SurveyTypeURL } from "../Enums/constants";
import ValidationTable from "./TableComponents/DB/Validation Table/ValidationTable";

const IbsSubmitPage = observer((props) => {
    const clickValidate = () => {
        generalStore.loadingErrorSummaryDone = false;
        validateSurveyCrtl();

    }

    const clickSubmit = () => {
        submitSurveyCtrl();
    }

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

    let isValidated = false;
    let hasChecked = ibsStore.checkedSurvey;

    if (typeof ibsStore.currentSurvey !== 'undefined' && typeof ibsStore.currentSurvey.SurveyStatusID !== 'undefined') {
        //not sure all the 'validated' status

        isValidated = ibsStore.currentSurvey.SurveyStatusID != null && ibsStore.currentSurvey.SurveyStatusID != 0;//any validated value, could also be null
    }

    let warningsDesc = undefined;

    let hasWarningsFlag = false;
    // Don't trust generalStore.allWarnings.length
    // This code goes through all the tab titles and if it finds one with a warning in allValidationErrorsList it adds the tab to the error summary
    if (generalStore.allWarnings.length > 0) {
        warningsDesc = [];
        let firstPageFlag = true;
        for (let page of generalStore.availPageTitles) {
            let pageIdentity = page.replaceAll(' ', '').replaceAll('&', '').toLowerCase();
            for (let pageWarningId in generalStore.allValidationErrorsList[pageIdentity]) {
                let pageWarning = generalStore.allValidationErrorsList[pageIdentity][pageWarningId];
                if (pageWarning.ErrorType != 0 && !pageWarning.ErrorExplanation && page.replaceAll(' ', '').toLowerCase !== "ltdpartnerships") {
                    if (firstPageFlag) {
                                warningsDesc.push(<span>The following tabs have unusual data items: </span>);
                    }
                    warningsDesc.push(
                        <span>
                            {!firstPageFlag && <span>, </span>}
                            <NavLink tag={Link} to={generalStore.surveyTypeUrl + page.replaceAll(' ', '').replaceAll('&', '')} className="plain-link">
                                {pageNameDisplayOverride(page)}
                            </NavLink>
                        </span>);
                    firstPageFlag = false;
                    break;
                }
            }
        }
        if (!firstPageFlag) {
            warningsDesc.push(". The items are highlighted in yellow. Please check off each item, and if possible, explain why the data is unusual in the 'Add explanation' field that appears when you click the link. After looking over the unusual data items highlighted in yellow, click submit below.");
        }
       
    }

    let errorDesc = undefined;
    if(generalStore.errorSummary.length > 0) {

        errorDesc = [];

        let firstPageFlag = true;
        
        for (let page of generalStore.availPageTitles) {
            let pageIdentity = page.replaceAll(' ', '').replaceAll('&', '').toLowerCase();
            for (let pageWarningId in generalStore.allValidationErrorsList[pageIdentity]) {
                let pageError = generalStore.allValidationErrorsList[pageIdentity][pageWarningId];
                if (pageError.ErrorType == 0 && !pageError.ErrorExplanation && page.replaceAll(' ', '').toLowerCase !== "ltdpartnerships") {
                    if (firstPageFlag) {
                        errorDesc.push(<span>The following tabs have problems that must be fixed before you can submit your data: </span>);
                    }
                    errorDesc.push(
                        <span>
                            {!firstPageFlag && <span>, </span>}
                            <NavLink tag={Link} to={generalStore.surveyTypeUrl + page.replaceAll(' ', '').replaceAll('&', '')} className="plain-link">
                                {pageNameDisplayOverride(page)}
                            </NavLink>
                        </span>);
                    firstPageFlag = false;
                    break;
                }
            }
        }
        if (!firstPageFlag) {
            errorDesc.push(". The problems are highlighted in pink. Point the cursor at each highlighted field to see specific error messages. After fixing all the problems highlighted in pink (and after checking the unusual data items highlighted in yellow), please submit your survey by clicking the submit button below.");
        }
       
    }
    
    let warningsAndError = undefined;
    let warningsAndErrorHeader = undefined;
    if ((warningsDesc && warningsDesc.length !== 0) && (errorDesc && errorDesc.length !== 0)) {
        warningsAndErrorHeader = <h5 style={{ color: '#95212c' }}>Errors and Unusual Items Found</h5>;
        warningsAndError = [...errorDesc, <br />, <br />, ...warningsDesc];
    } else if (warningsDesc && warningsDesc.length !== 0) {
        warningsAndErrorHeader = <h5 style={{ color: '#d1b654' }}>Unusual Items Found</h5>;
        warningsAndError = [...warningsDesc];
    } else if (errorDesc && errorDesc.length !== 0) {
        warningsAndErrorHeader = <h5 style={{ color: '#95212c' }}>Errors Found</h5>;
        warningsAndError = [...errorDesc];
    }
    else {
        warningsAndErrorHeader = <h5 style={{ color: '#508050' }}>Everything looks good!</h5>;
        warningsAndError = [];
    }

    // let showValidationTable = false;
    // let isMandateLevel = parseInt(getResponseValue("IsMandateLevel"))
    // if(isMandateLevel === AssetTableViewMode.MANDATE_ONLY_VIEW) {
    //     showValidationTable = true;
    // } else if (isMandateLevel === AssetTableViewMode.ASSET_ONLY_VIEW) {
    //     showValidationTable = true;
    // }
    let currencyPlaceHolderThousandForHeader = `|${PlaceholderFormat.CURRENCY_THOUSAND}|`;

    return (
        <React.Fragment>
            <br />
            <br />
            <SurveySection labelText="Step 1 - Validate">
                <div className="center">
                    <button type="button" className="btn btn-unlock"
                            disabled={isValidated || !generalStore.loadingErrorSummaryDone}
                            onClick={clickValidate}>Validate Survey
                    </button>
                </div>

                {!generalStore.loadingErrorSummaryDone &&
                <div className='sweet-loading'>
                    <BeatLoader
                        css={override}
                        sizeUnit={"px"}
                        size={25}
                        color={'#6aaaad'}
                        loading={!generalStore.loadingErrorSummaryDone}
                    />
                </div>
                }

                {hasChecked && <React.Fragment>
                    <div className="surveyRow">
                        {generalStore.loadingErrorSummaryDone && warningsAndErrorHeader && warningsAndError &&
                            <div className="errors-desc">
                                {warningsAndErrorHeader}
                                {warningsAndError}
                            </div>
                        }
                    </div>
                    <br />
                </React.Fragment>
                }
                {hasChecked &&
                <div>
                    {generalStore.surveyTypeUrl !== SurveyTypeURL.DC &&
                            <React.Fragment>

                                <div className="surveyRow">
                                    <br />
                                  
                                    <ValidationTable/>
                                </div>
                            </React.Fragment>
                    }

                </div>
                }
            </SurveySection>

            <SurveySection labelText="Step 2 - Submit Your Data">
                <div className="center">
                    
                    {(generalStore.errorSummary.length > 0 || !hasChecked) &&
                    <div style={{marginTop: '25px', marginBottom: '25px'}}>Please validate and clear all errors before
                        submitting the survey.</div>

                    }
                </div>
                <div className="center">
                    {!isValidated &&
                        <NavLink style={{zIndex:"1"}} tag={Link} onClick={clickSubmit} to={generalStore.surveyTypeUrl + "Unlock"}
                             className="btn btn-unlock"
                             disabled={generalStore.errorSummary.length > 0 || !hasChecked}>Submit Survey</NavLink>
                    }
                </div>
            </SurveySection>
            {props.children}
        </React.Fragment>
    );
});
export default IbsSubmitPage;


//{
//    isValidated &&
//    <div style={{ marginTop: '25px', marginBottom: '25px' }}>Thank you for your submission. We will
//        contact you with follow-up questions, if any, in the next few days. In the meanwhile, if you
//        have any questions, please contact John Simmonds at johns@cembenchmarking.com or +44 203 887
//                        9289.</div>

//}